module.exports = __webpack_public_path__ + "static/media/modal-novo-robo-lances.6ef144c1.jpg";